import { defineMessages } from 'react-intl';

export default defineMessages({
    addressLookUpOverride: {
        id: 'farm.address-lookup-component.Override',
        defaultMessage: 'Override'
    },
    addressLookupAddressLine1:{
        id: 'farm.address-lookup-component.AddressLine1',
        defaultMessage: 'Address Line 1' 
    },
    addressLookupAddressLine2:{
        id: 'farm.address-lookup-component.AddressLine2',
        defaultMessage: 'Address Line 2' 
    },
    addressLookupAddressLine3:{
        id: 'farm.address-lookup-component.AddressLine3',
        defaultMessage: 'Address Line 3' 
    },
    addressLookupCity:{
        id: 'farm.address-lookup-component.City',
        defaultMessage: 'City' 
    },
    addressLookupState:{
        id: 'farm.address-lookup-component.Province',
        defaultMessage: 'Province' 
    },
    addressLookupCountry:{
        id: 'farm.address-lookup-component.Country',
        defaultMessage: 'Country' 
    },
    addressLookupPostalCode:{
        id: 'farm.address-lookup-component.PostalCode',
        defaultMessage: 'Postal Code' 
    },
    addressLookupAddressType:{
        id: 'farm.address-lookup-component.MailingAddress',
        defaultMessage: 'Mailing Address' 
    },
    addAddressButton:{
        id: 'farm.address-lookup-component.Add',
        defaultMessage: 'Add' 
    },
    saveAddressButton:{
        id: 'farm.address-lookup-component.Save',
        defaultMessage: 'Save' 
    },
    cancelAddressButton:{
        id: 'farm.address-lookup-component.Cancel',
        defaultMessage: 'Cancel' 
    }
});
